module.exports = __webpack_public_path__ + "img/cup-togo.a61a4e95.svg";